export enum Kpi {
  REVENUE = "REVENUE",
  MARGIN = "MARGIN",
  ORDERS = "ORDERS",
  PROFIT = "PROFIT",
}

export enum StandardPeriod {
  LAST_MONTH = "LAST_MONTH",
  LAST_3_MONTHS = "LAST_3_MONTHS",
  LAST_6_MONTHS = "LAST_6_MONTHS",
  LAST_12_MONTHS = "LAST_12_MONTHS",
  YEAR_TO_DATE = "YEAR_TO_DATE",
}

export enum Granularity {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  YEARLY = "YEARLY",
}

export enum KpiComparisonMode {
  PERIOD_OVER_PERIOD = "PERIOD_OVER_PERIOD",
  YEAR_OVER_YEAR = "YEAR_OVER_YEAR",
}

export interface KpiDataPoint {
  periodStart: Date;
  value: number;
}

export interface KpiChangeSummary {
  percentageChange?: number | null;
}
